<!-- 销售控销数据操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="dataActionBox.boxTitle" :name="'jciName'"
                        :value="'jciName'" :tabslist="tabForm">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form class="baseForm" id="mainInfo" label-width="150px" :model="sendDataInfo"
                                        ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2" ref="baseForm">
                                            <el-form-item label="单位名称" prop="unitName"
                                                :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                                <el-input v-model="sendDataInfo.unitName" placeholder="请输入单位名称"
                                                   >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="类型" prop="quaType"
                                                :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                                <el-select v-model="sendDataInfo.quaType" placeholder="请选择"
                                                    @change="selectChange">
                                                    <el-option v-for="item in options" :key="item.value" :label="item.key"
                                                        :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="备注" prop="remark"
                                                :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                                <el-input v-model="sendDataInfo.remark" type="textarea"
                                                    :disabled="sendDataInfo.type == 3">
                                                    
                                                </el-input>
                                            </el-form-item>
                                         
                                        </el-row>
                                    </el-form>
            
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foot">
                    <div>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 0">保存</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 1">保存</el-button>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
                @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>
 
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
export default {
    name: "qualifapplyInitListAction",
    props: ["actionData"],
    data() {
        //这里存放数据
        return {
            mxHeight: 0,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            selectedDetailsIndex: 0,//控销类型列表的索引
            selectedProductIndex: 0,//商品列表的索引
            sendDataInfo: {
                remark:"",
                quaType:"",
                unitName:"",
                quaId:""
            },
            smIntype: [],//购进单位类型
            cmIntype: [],//销往单位类型
            typeValueList: [],//临时控销参数集合组
            typelist: [],//单位类型列表
            typelists: [],//购进单位类型
            regionlist: [],//地域列表
            productlist: [],//商品列表头部列表
            detailList: [],//商品列表
            //控销类型组
            options: [
                {
                    key: "上游",
                    value: 0
                },
                {
                    key: "下游",
                    value: 1
                },
              
            ],
            seId: "",
            seWidth: "",
            seTitle: "",
            DialogVisible: false,
            seType: "",
            seIndex: 0, //选中索引
            smId: "",
            parentSearchData: {},
            isLoaded: false,
            tabForm: [
                {
                    jciName: "",
                }
            ], // tab循环的主表单
            sField: "", // 赋值字段
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        //查询控销区域
        async goodControlqueryControlAreaList() {
            const res = await this.$http.goodControlqueryControlAreaList()
            console.log(res);
            this.regionlist = res.result
        },
        //控销类型控制列表
        selectChange() {
            if (this.sendDataInfo.type == 0) {
                this.formDataList = this.actionData.formData.typelist
                this.typeValueList = []
                this.getPartDictionariesData()
            } else if (this.sendDataInfo.type == 1) {
                this.formDataList = this.actionData.formData.buyerlist
                this.typeValueList = []
            } else if (this.sendDataInfo.type == 2) {
                this.typeValueList = []
                this.goodControlqueryControlAreaList()
                this.formDataList = this.actionData.formData.regionlist

            } else if (this.sendDataInfo.type == 3) {
                this.typeValueList = []
                this.sendDataInfo.businessType = 0
                this.getPartDictionariesData()
            }
        },
        //购进单位类型
        smIntypeChange() {
            if (this.smIntype.length != null && this.smIntype.length != 0) {
                this.sendDataInfo.smIntype = this.smIntype.join()
            }
        },
        //销往单位类型
        cmIntypeChange() {
            if (this.cmIntype.length != null && this.cmIntype.length != 0) {
                this.sendDataInfo.cmIntype = this.cmIntype.join()
            }
        },
        //单位类型列表
        async getPartDictionariesData() {
            const res = await this.$http.getPartDictionariesData({ ids: [38, 16] })
            this.typelist = res.result.KHDWLX
            this.typelists = res.result.dwlx
        },
        //删除控销类型明细组
        deleteDetails() {
            if (this.typeValueList.length > 0) {
                this.typeValueList.splice(this.selectedDetailsIndex, 1)
                this.selectedDetailsIndex = this.typeValueList.length - 1
            } else {
                this.$message.error("暂无数据")
            }
        },
        //新增控销类型明细组
        addDetail(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    var obj = {};
                    var flag = false
                    this.formDataList.forEach(item => {
                        if (item.fieldType == 'search') {
                            const arr = item.setField.split(",")
                            arr.forEach(item1 => {
                                obj[item1] = ""
                            })
                        } else {
                            obj[item.entityField] = ""
                        }
                    })
                    if (this.typeValueList.length > 0) {
                        this.typeValueList.forEach(item => {
                            for (const key in obj) {
                                if (item[key] == "") {
                                    flag = true
                                }
                            }
                        })
                    }
                    if (flag) {
                        return this.$message.warning("已有空白行")
                    }
                    this.typeValueList.push({})
                    this.selectedDetailsIndex = this.typeValueList.length - 1
                    this.$set(this.typeValueList, this.typeValueList.length - 1, obj)
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            })
        },
        //删除商品列表数据
        deleteProductDetails() {
            if (this.detailList.length > 0) {
                this.detailList.splice(this.selectedProductIndex, 1)
                this.selectedProductIndex = this.detailList.length - 1
            } else {
                this.$message.error("暂无数据")
            }
        },
        //添加商品列表数据
        addProductDetail(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    var obj = {};
                    var flag = false
                    this.productlist.forEach(item => {
                        if (item.fieldType == 'search') {
                            const arr = item.setField.split(",")
                            arr.forEach(item1 => {
                                obj[item1] = ""
                            })
                        } else {
                            obj[item.entityField] = ""
                        }
                    })
                    if (this.detailList.length > 0) {
                        this.detailList.forEach(item => {
                            for (const key in obj) {
                                if (item.bgmId == "" || item.bgmName == "" || item.bgmCode == "") {
                                    flag = true
                                }
                            }
                        })
                    }
                    if (flag) {
                        return this.$message.warning("已有空白行")
                    }
                    this.detailList.push({})
                    this.selectedProductIndex = this.detailList.length - 1
                    this.$set(this.detailList, this.detailList.length - 1, obj)
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            })
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                if (this.seType == 'bgmName') {
                    this.detailList[this.selectedProductIndex][item] = val[item];
                } else {
                    this.typeValueList[this.selectedDetailsIndex][item] = val[item];
                }
            });
        },
        //提取返回
        changeInputModel(val) {
            console.log("返回", val);
            if (val != "" && val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.parentSearchData[type] = this.sendDataInfo[type];
        },
        //初始字段
        init() {
            for (const key in this.sendDataInfo) {
                if (key == 'typeValueList' || key == 'detailList') {
                    this.sendDataInfo[key] = []
                } else {
                    this.sendDataInfo[key] = ""
                }
            }
            this.sendDataInfo['businessType'] = 1
            this.typeValueList = []
            this.detailList = []
        },
        //初次进入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            var oldData = this.actionData.oldData;
            var obj = {};
      
       
           
            this.init()
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "ltr";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in this.sendDataInfo) {
                    if (key == 'detailList' || key == 'typeValueList') {
                        this.sendDataInfo[key] = []
                    }else{
                        this.sendDataInfo[key] = dataInfo[key];
                    } 
                }
              
        

            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in this.sendDataInfo) {
                    if (key == 'detailList' || key == 'typeValueList') {
                        this.sendDataInfo[key] = []
                    } else {
                        this.sendDataInfo[key] = dataInfo[key];
                    }
                }
                oldData.typeValueList.forEach(item => {
                    const objs = {}
                    for (const key in obj) {
                        if (key == 'cmId' || key == 'regionName' || key == 'diName') {
                            objs[key] = item['typeValue']
                        } else {
                            objs[key] = item[key]
                        }
                    }
                    this.typeValueList.push(objs)
                })
                oldData.detailList.forEach(item => {
                    const productObjs = {}
                    for (const key in productObj) {
                        productObjs[key] = item[key]
                    }
                    this.detailList.push(productObjs)
                })
            }
            this.tabForm[0].jciName = this.dataActionBox.boxTitle

            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getBtnHeight()
                    }
                }, 16.7)
            });
        },
        //取消
        initActionBox(sendDataInfo) {
            this.$emit("drawerCancel", 0);
            this.init();
            this.$refs[sendDataInfo].resetFields();
        },
        //新增和修改
        sendDataAction(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    // console.log('sendDataInfo',this.sendDataInfo)
                    this.sub();
                } else {
                    this.$message({
                        message: "请完善主表单必填信息",
                        type: "error",
                    });
                    flag = true;
                    return false;
                }
            });
        },
        //新增和修改提交
        async sub() {
          
          
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.qualifapplyAdd(this.sendDataInfo);
            } else {
                var responseData = await this.$http.qualifapplyUpdate(this.sendDataInfo);
            }
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", 1);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();
            this.isLoaded = true;
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeDestroy() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
 
<style scoped>
/* ::v-deep .current-row td {
    background-color: #fff7ca !important;
} */
.el-table .rowStyle {
    background: #fff7ca !important;
}

.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 2px;
}

.el-drawer {
    outline: none;
}

.v-modal {
    position: static !important;
    width: 100%;
    height: 100%;
    background: transparent;
}

#mainInfo {
    padding-bottom: 5px !important;
}

.details {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.details .left {
    width: 35%;
    flex-shrink: 0;
}

.details .right {
    width: 64%;
    flex-shrink: 0;
}

.details .active {
    width: 100%;
    flex-shrink: 0;
}
</style>